let isTouch = false;

if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
  isTouch = true;
}

export default isTouch;